import ConvenienceRoom from './ConvenienceRoom.container';

export default ConvenienceRoom;
